import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatMenuTrigger, MatMenuModule, MatMenuPanel, MAT_MENU_PANEL } from '@angular/material/menu';
import { DisplayText } from 'src/app/models/events/displayText';
import { EventsAction } from 'src/app/models/events/eventsAction';
import { EventColumn } from 'src/app/models/events/eventsColumn';
@Component({
    selector: 'app-popup-btn-action',
    templateUrl: './popup-btn-action.component.html',
    styleUrls: ['./popup-btn-action.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupBtnActionComponent implements OnInit {
  
  constructor() { }
  @ViewChild('plusContent', { static: false }) divPlusContent: ElementRef;
  menuSelectVal = "Aucun"

  ngOnInit(): void {
  
  }
  

  togglePlusContent(val: string, show : boolean, e) {
    
    e.stopPropagation() 
    show ? this.divPlusContent.nativeElement.classList.add('show') : this.divPlusContent.nativeElement.classList.remove('show')
    this.menuSelectVal = val ? val : "Aucun"
  }

}
